import type { NDateLocale } from './enUS'
import { th } from 'date-fns/locale'

const dateThTH: NDateLocale = {
  name: 'th-TH',
  locale: th
}

export default dateThTH
